<div id="sensor-detail-data">
  <div *ngIf="!shouldGraphBeDisplayed()" class="alert alert-warning" role="alert">
    {{ NO_OBSERVATIONS_AVAILABLE }}
  </div>

  <div *ngIf="shouldLoadingSpinnerBeDisplayed()" class="charLoading active">
    <i class="fa fa-spinner loading" aria-hidden="true"></i>
    <p>{{ LOADING_TEXT }}</p>
  </div>

  <li hidden="true" >{{ this.updateSingleCurrentFeature(this.streamNotificationService.getFeature()) }}</li>

  <app-sensor-observations-chart
    [hidden]="!shouldGraphBeDisplayed()"
    [sensor]="sensor"
    [(observations)]="observations"
    (manualDateSelect)="getObservationsByDate($event)">
  </app-sensor-observations-chart>

  <button *ngIf="shouldLoadMoreDataButtonBeDisplayed()"
          class="btn btn-warning mt-2 float-right"
          (click)="onLoadMoreDataClick()">
    load more data
  </button>

  <button *ngIf="shouldLoadingMoreDataIndicatorBeDisplayed()" class="btn-warning mt-2 float-right">
    loading...
  </button>

</div>
